import { AutoPositionStatus } from '@shure/shared/angular/data-access/system-api/core';
import {
	BeamWidth,
	ChannelGroup,
	DeviceModel,
	PolarPattern
} from '@shure/shared/angular/data-access/system-api/models';
import { PositionPoint, PositionUnit } from '@shure/shared/angular/utils/utils-position';

import { FeatureSet } from './coverage-device';
import { NumberRange, PositionUnitRange, TextConstraints } from './utils';

export const AUDIO_CHANNEL_DEFAULTS: Pick<CoverageAudioChannelFeatures, 'beam' | 'beamWidth' | 'beamLength'> = {
	beam: { x: PositionUnit.fromRaw(0), y: PositionUnit.fromRaw(0) },
	beamWidth: BeamWidth.Medium,
	beamLength: PositionUnit.fromRaw(0)
};

export type NumberConstraints = NumberRange;

export type CoverageAudioChannelConstraints = {
	name: TextConstraints | undefined;
	micAngle: NumberConstraints | undefined;
	gain: NumberConstraints | undefined;
	beam?: {
		axisX: PositionUnitRange;
		axisY: PositionUnitRange;
		axisZ?: PositionUnitRange;
	};
	talkerHeight?: NumberConstraints;
};

export type CoverageAudioChannelFeatures = {
	autofocusBeam: PositionPoint;
	beam: PositionPoint;
	beamWidth: BeamWidth;
	/** The difference between device height and lobe talker height */
	beamLength: PositionUnit;
	name: string;
	danteChannelName: string;
	identify: boolean;
	mute: { muted: boolean; isPostGate: boolean; isPreGate?: boolean };
	gain: { gain: number; isPostGate: boolean };
	micAngle: number;
	micPolarPattern: PolarPattern;
	autofocusTalkerHeight: PositionUnit;
	autofocusMicAngle?: number;
	autoPositionSupported: boolean;
	/** @deprecated Please use {@link AutoPositionDialogService} to open {@link AutoPositionDialogComponent} */
	autoPosition: AutoPositionStatus;
	preGateMute: boolean;
	talkerHeight?: PositionUnit;
};

export type CoverageAudioChannel = {
	id: string;
	index: number;
	group: ChannelGroup;
	enabled: boolean;
	device: { id: string; model: DeviceModel; virtual: boolean };
	constraints: CoverageAudioChannelConstraints;
	features: FeatureSet<CoverageAudioChannelFeatures>;
};
